export const allMandatory = (...args: unknown[]) => args && args.length > 0 && args.every(Boolean);
